<template>
  <div class="xferBackground">
    <portal-target name="xferBack"></portal-target>
    <div class="header" @click="dumpAmounts"
         :style="{ fontSize: fonts.font26 + 'px' }">Transfer Money</div>
    <div v-if="cuVal === 6"> <!-- [174] -->
      <div class="xferLockout">
        Transfer of money is disabled.<br />
        <b-button
          @click="goBack"
          class="exitButton"
          :style="{ fontSize: fonts.font14 + 'px' }"
          >Exit</b-button>
      </div>
    </div>
    <div class="topContainer" v-if="cuVal !== 6"> <!-- [174] Added cuVal -->
      <div class="simpleSelectBox" v-if="xfCount > 0">
        <div class="sourceSelector">
          <span class="selectHead">Source Account</span>
          <div>
            <b-dropdown id="dropdown-source" :text="sourceLabel" :variant="sLabColor" class="m-2">
              <b-dropdown-text style="width: 300px;" class="dropHead">
                {{xfList.arr[0].acct}} {{xfList.arr[0].name}}
              </b-dropdown-text>
              <div v-for="i in xfList.arr[0].items" :key="i.key">
                <b-dropdown-item-button
                    v-if="i.vSource > 0"
                    class="dropItem"
                    :style="i.sStyle"
                    @click="sClick(0, i)">
                  {{ i.full }}
                </b-dropdown-item-button>
              </div>
            </b-dropdown>
            <div style="height: 30px;">{{xfAvail}}</div>
          </div>
        </div>
        <div class="destinSelector">
          <span class="selectHead">Destination Account</span>
          <div>
            <div class="selectDestClass">
              <b-dropdown id="dropdown-destin" :text="destinLabel" :variant="dLabColor" class="m-2">
                <div v-for="a in xfList.arr" :key="a.key" class="destBox">
                  <div v-if="otherPin === true &&
                  includeSubs === false &&
                  a.acct !== xfList.arr[0].acct">
                    <b-dropdown-text style="width: 260px;" class="dropHead">
                      {{a.acct}} {{a.name}}
                    </b-dropdown-text>
                    <div v-for="i in a.items"
                         :key="i.key"
                         class="destItems">
                      <b-dropdown-item-button
                        v-if="i.vDestin > 0"
                        class="dropItem"
                        :style="i.dStyle"
                        @click="dClick(a, i)">
                        {{i.fullx}}
                      </b-dropdown-item-button>
                    </div>
                  </div>
                  <div v-if="otherPin === false || includeSubs === true">
                    <div v-if="includeSubs === true || a.acct === xfList.arr[0].acct">
                      <b-dropdown-text style="width: 260px;" class="dropHead">
                        {{a.acct}} {{a.name}}
                      </b-dropdown-text>
                      <div v-for="i in a.items"
                           :key="i.key"
                           class="destItems">
                        <b-dropdown-item-button
                          v-if="i.vDestin > 0"
                          class="dropItem"
                          :style="i.dStyle"
                          @click="dClick(a, i)">
                          {{i.fullx}}
                        </b-dropdown-item-button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-dropdown>
              <b-button v-if="destinLabel === xdh"
                        @click="goOther"
                        class="cssOther">
                Other
              </b-button>
            </div>
            <div class="includeSubs">
              <b-check v-model="includeSubs">Sub-Accounts on Dropdown</b-check>
            </div>
          </div>
        </div>
      </div>
      <div class="amtContainer">
        <div class="outBoxAmount">
          <div class="amtBox">
            <b-form-input
              class="amtInput"
              aria-label="Enter Amount"
              autocomplete="nope"
              autocorrect="off"
              autocapitalize="off"
              type="text"
              v-model="form.amount"
              @blur.native="onBlurAmount"
              required
              placeholder="Enter Amount">
            </b-form-input>
            <b-dropdown
              id="dropdown-amounts"
              text=""
              right
              variant="link"
              class="m-2"> <!-- [131] Add Variant="link" -->
              <b-dropdown-text style="width: 300px;" class="dropHead">
                Select Amount
              </b-dropdown-text>
              <div v-for="i in amounts" :key="i.key">
                <b-dropdown-item-button
                  class="dropItem"
                  @click="aClick(i)">
                  {{ i.text }}
                </b-dropdown-item-button>
              </div>
            </b-dropdown>
          </div>
        </div>
        <div class="outBoxButtons">
          <div class="btnGroup">
            <b-button v-show="submitValid.valid"
                      id="btnSubmit"
                      class="cssSubmit"
                      @click="submit">
              Transfer
            </b-button>
            <b-button v-show="!submitValid.valid"
                      id="btnSubmitDisabled"
                      class="cssSubmitDisabled"
                      @click="invalid">
              Transfer
            </b-button>
            <b-button id="btnCancel"
                      class="cssCancel"
                      @click="goBack">
              Cancel
            </b-button>
            <b-button id="btnHelp"
                      class="cssHelp"
                      @click="goHelp">
              Help
            </b-button>
            <b-button id="setupPins"
                      class="cssPins"
                      @click="goPins">
              Pins
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="showXferHelp" class="helpBox">
        <div class="helpBoxCenter"
             :style="{ fontSize: fonts.font30 + 'px' }">
          Transfer Money Help</div>
        <div class="helpBoxLeft"
             :style="{ fontSize: fonts.font18 + 'px' }">
          Transferring money is easy:<br />
          <ol>
            <li>Select the source account</li>
            <li>Select the destination account</li>
            <li>Enter (or select) the dollar amount</li>
            <li>Click TRANSFER</li>
            <li>On the confirmation page, Click OK</li>
          </ol>
          <p>See, wasn't that simple?
          But what if you want to transfer money to a secondary account number or
          to a totally different member?<br />
          Let's cover the steps in detail.</p>
        </div>
        <div class="helpBoxCenter"
             :style="{ fontSize: fonts.font20 + 'px' }">
          Source Account</div>
        <div class="helpBoxLeft"
             :style="{ fontSize: fonts.font16 + 'px' }">
          <p>The Source Account is a share account you are transferring money FROM
            or an open-end loan you are doing an ADD-ON to. This must be a share or
            loan on the account you are signed into.  Click on the
            SELECT SOURCE dropdown box to select a valid source account.
            Once selected, the source account will be displayed and the box will turn green.
          </p>
        </div>

        <div class="helpBoxCenter"
             :style="{ fontSize: fonts.font20 + 'px' }">
          Destination Account</div>
        <div class="helpBoxLeft"
             :style="{ fontSize: fonts.font16 + 'px' }">
          <p>The Destination Account is a share account you are transferring money TO
            or a loan you are making a payment on. Click in the
            SELECT DESTINATION dropdown box to select a destination that is
            on your own account (the one you are signed into).
            The credit union can setup up sub-accounts on your main account and
            they will show up on the destination drop-down list.
            This will prevent you needing to enter a PIN each time you transfer money.
            Once selected, the destination account will be displayed and the box
            will turn green.<br />
          </p>
        </div>
        <div class="helpBoxCenter"
             :style="{ fontSize: fonts.font20 + 'px' }">
          "OTHER" Destination Account</div>
        <div class="helpBoxLeft"
             :style="{ fontSize: fonts.font16 + 'px' }">
          <p>It's possible to transfer money to a member account that is not
            setup as a sub-account by clicking the OTHER button. Due to security
            restrictions, you must receive a 6-DIGIT authorization PIN to a phone number
            currently defined on the account you are logged into. A new PIN will be
            generated each time you transfer money via OTHER.  This prevents
            someone with access to your account (spouse?) from being able to transfer
            money out if they don't have access to a phone number that's on the account.
            The "other" member will be required to setup a 4-DIGIT PIN on their account that
            they will give you to allow you to transfer money to them.  After you receive the
            6-DIGIT PIN on your phone, enter that in the top box, then enter the
            account number of the "other" member, then enter the PIN they gave you.  Once you
            click OK, the Destination Drop-Down box will contain the "other" member's shares
            and loans.  Balances and payment amounts can be HIDDEN, depending on the PIN they
            give you (see next section).
          </p>
          <div :style="{ fontSize: fonts.font20 + 'px' }">
            <b style="color: red">To setup the destination PIN for OTHER account:</b></div>
          <div>
            <pin-setup-help></pin-setup-help><!-- [172] -->
            For More detail, see the next section (PIN Button setup)
          </div>
        </div>
        <div class="helpBoxCenter"
             :style="{ fontSize: fonts.font20 + 'px' }">
          PIN button (setup Destination Pin)</div>
        <div class="helpBoxLeft"
             :style="{ fontSize: fonts.font16 + 'px' }">
          <p>If someone needs to transfer money to your account, you will
            need to setup a PIN for them to use. Each pin is four digits (1000 to 9999),
            or blank if disabled.  You can enter any 4-digit number you choose.</p>
            There are two PIN types.
          <ol>
            <li>Visible Balances PIN</li>
            <li>Hidden Balances PIN</li>
          </ol>
          <p>If you want to hide your balances and payment amount from the member
            transferring money to you, give them the "Hidden Balances PIN".  If you give
            them the "Visible Balances PIN", they will be able to see your balances.
            Due to security restrictions, a 6-Digit Authorization PIN must be sent
            to a phone number defined on your account before it allows you to see
            or change a PIN.</p>
          <p>There is also a ONE-TIME-ONLY check box for each PIN.
            If checked, that PIN will be blanked out after it gets used.
          </p>
          <p>Normal PINS are valid until you change them.  ONE-TIME PINS are valid until
            they get used by someone, at which time they blank out.
          </p>
        </div>
        <div class="helpBoxCenter"
             :style="{ fontSize: fonts.font20 + 'px' }">
          Enter Amount</div>
        <div class="helpBoxLeft"
             :style="{ fontSize: fonts.font16 + 'px' }">
          <p>Enter the dollar amount you wish to transfer from the source
            to the destination account.  You can optionally click the arrow next to
            the amount to drop-down a list of possible amounts. After you have selected
            the source account, the Available amount will show in the drop-down list.
            If you have selected a destination loan, the payment, payoff, and possible
            delinquent amount will show in the drop-down list.
          </p>
        </div>
        <div class="helpBoxCenter"
             :style="{ fontSize: fonts.font20 + 'px' }">
          Show Account Detail</div>
        <div class="helpBoxLeft"
             :style="{ fontSize: fonts.font16 + 'px' }">
          <p>This provides an alternate method of selecting accounts and
            allows you to see more details about the source and destination
            accounts, but would not normally be needed or used.
            Clicking "Show Account Detail" will show this detail
            and clicking again will hide it.<br />
          </p>
        </div>
        <b-button class="cssHideHelp"
                  @click="goHelp">
          Hide Help
        </b-button>
      </div>
      <div v-if="detail === false"
                class="detailButton"
                @click="toggleDetail">
        Show Account Detail
      </div>
      <div v-if="detail === true"
                class="detailButton"
                @click="toggleDetail">
        Hide Account Detail
      </div>
    </div>
    <div v-if="detail === true">
      <b-form id="siForm" v-if="xfCount > 0">
        <div class="sourceWind">
          <div class="sourceHeadText" :style="{ fontSize: fonts.font18 + 'px' }">
            Source Account
          </div>
          <b-collapse visible id="sCard" class="bCard">
            <div class="bCard" :style="{ fontSize: fonts.font14 + 'px' }">
              <div class="groupHeader">
                <span class="grHead" style="width: 50%">Account Description</span>
                <span class="grHead" style="width: 25%">Available</span>
                <span class="grHead" style="width: 25%">Balance</span>
              </div>
              <div v-for="i in xfList.arr[0].items"
                   :key="i.key"
                   class="sourceItems">
                <div v-if="i.vSource > 0">
                  <div class="groupSection">
                    <b-form-checkbox
                      @change="sClick(0, i)"
                      class="seCheck"
                      v-model="i.source"
                      >{{ i.full }}
                    </b-form-checkbox>
                    <div class="grRight" style="width: 25%">{{ i.$avail }}</div>
                    <div class="grRight" style="width: 25%">{{ i.$bal }}</div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="destinWind">
          <div class="destHeadText"
               @click="expandAllDestAcct(xfList.arr[0].aPnt)"
               :style="{ fontSize: fonts.font18 + 'px' }">
            Destination Account
          </div>
          <b-collapse visible id="dCard" class="bCard">
            <div class="bCard" :style="{ fontSize: fonts.font14 + 'px' }">
              <div v-for="a in xfList.arr" :key="a.key" class="destBox">
                <div @click="toggleDestAcct(a.aPnt)"
                     :style="{ fontSize: fonts.font18 + 'px' }"
                     class="destHead">
                  {{ a.destHead }}
                </div>
                <div v-show="a.expand">
                  <div class="groupHeader" style="text-align: center">
                    <span class="grHead" style="width: 50%">Account Description</span>
                    <span class="grHead" style="width: 25%">Payment</span>
                    <span class="grHead" style="width: 25%">Balance</span>
                  </div>
                  <div v-for="i in a.items"
                       :key="i.key"
                       class="destItems">
                    <div class="groupSection" v-if="i.vDestin > 0">
                      <b-form-checkbox
                        @change="dClick(a, i)"
                        style="width: 50%"
                        class="seCheck"
                        v-model="i.destin">{{ i.full }}
                      </b-form-checkbox>
                      <div class="grRight" style="width: 25%">{{ i.payDest }}</div>
                      <div class="grRight" style="width: 25%">{{ i.$balDest }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </b-form>
    </div>
    <portal to="xferBack">
      <b-button
        @click="goBack"
        :style="{ fontSize: fonts.font14 + 'px' }"
        class="btnBack">Back</b-button>
    </portal>
  </div>
</template>

<script>
import utl from '../myUtils';
import pinSetupHelp from './pinSetupHelp';

export default {
  components: {
    pinSetupHelp,
  },
  name: 'xfer',
  data() {
    return {
      form: {
        source: null,
        destin: null,
        amount: null,
        from: null,
        to: null,
      },
      detail: false,
      includeSubs: true,
      visi: false,
      valError: 0,
      showXferHelp: false,
      lastError: 0,
    };
  },
  watch: {
    xfChange() {
      this.checkDrops();
      this.$forceUpdate();
    },
    mySecond() {
      this.intervalSecond();
    },
  },
  computed: {
    cuVal() {
      return this.$store.getters.getCuVal;
    },
    alertErrorNumber() {
      return this.$store.getters.getAlertError;
    },
    otherPin() {
      return this.$store.getters.getOtherPin;
    },
    xsh() {
      return this.$store.getters.getXSH; // XSH = Blank Xfer Source Header
    },
    xdh() {
      return this.$store.getters.getXDH; // XDH = Blank Xfer Destination Header
    },
    xfAvail() {
      return this.$store.getters.getXferAvailable;
    },
    sourceAvail() { // [144]
      let avail = '0.00';
      try {
        const xf = this.xfAvail.split(':');
        // utl.diag(xf[0]);
        // utl.diag(xf[1]);
        avail = utl.fmtDolCent(xf[1]);
        // utl.diag(avail);
      } catch (e) {
        avail = '0.00'; // try/catch got error
      }
      return avail;
    },
    sourceLabel() {
      return this.$store.getters.getSourceHeader;
    },
    destinLabel() {
      return this.$store.getters.getDestinHeader;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    xfChange() {
      return this.$store.getters.getXfChange;
    },
    xfCount() {
      return this.$store.getters.getXfCount;
    },
    xfList() {
      return this.$store.getters.getXfList;
    },
    amounts() {
      return this.$store.getters.getAmountsList;
    },
    mySecond() {
      return this.$store.getters.getMySecond;
    },
    submitValid() {
      // utl.diag('-----------------------------------------');
      this.clearAlert();
      let valid = true;
      const err = [];
      for (let i = 0; i < 9; i += 1) {
        err[i] = 0;
      }
      if (this.form.source === null) {
        valid = false;
        err[1] = 1;
      }
      if (this.form.destin === null) {
        valid = false;
        err[2] = 1;
      }
      if (this.sourceLabel === this.destinLabel) {
        valid = false;
        err[3] = 1;
      }
      if (this.sourceLabel === this.xsh) {
        valid = false;
        err[3] = 2;
      }
      if (this.destinLabel === this.xdh) {
        valid = false;
        err[3] = 3;
      }

      if (this.form.amount === null) {
        valid = false;
        err[4] = 1;
      } else {
        const amt = utl.fmtDolCent(this.form.amount);
        // const amt = utl.fmtDollar(this.form.amount.trim());
        // utl.diag(`submitValid - amt=${amt}`);
        const num = Math.round(parseFloat(amt) * 100);
        // utl.diag(`submitValid - num=${num}`);
        if (isNaN(num)) {
          valid = false;
          err[4] = 2;
        }
        if (num < 1) {
          valid = false;
          err[4] = 3;
        }
        if (valid === true) { // [144]
          const myAvail = utl.dollar100(this.sourceAvail);
          const myAmount = utl.dollar100(amt);
          // utl.diag(`myAvail:  ${myAvail}`);
          // utl.diag(`myAmount: ${myAmount}`);

          // utl.diag(`Avail: ${utl.stripDollar(this.sourceAvail)}`);
          // utl.diag(`Speci: ${amt}`);
          if (myAmount > myAvail) {
            valid = false;
            err[5] = 1;
          }
        }
      }
      let error = 0; // Return the FIRST error (not the last one)
      for (let i = 0; i < 9; i += 1) {
        if (err[i] > 0) {
          error = i;
          // utl.diag(`err[${i}] = ${err[i]}`);
          break;
        }
      }
      const val = [];
      val.valid = valid;
      val.error = error;
      return val;
    },
    xfs() {
      return this.$store.getters.getXFS;
    },
    sLabColor() {
      let sLabColor = 'danger';
      if (this.sourceLabel !== this.xsh) { // xsh=blank label
        sLabColor = 'success';
      }
      return sLabColor;
    },
    dLabColor() {
      let dLabColor = 'danger';
      if (this.destinLabel !== this.xdh) { // xdh=blank label
        dLabColor = 'success';
      }
      return dLabColor;
    },
  },
  methods: {
    intervalSecond() {
      // if (error === 213) msg = 'Other Member Account # or "Destination PIN" is invalid';
      if (this.alertErrorNumber === 213) {
        if (this.lastError !== 213) {
          this.lastError = 213;
          this.showXferHelp = true; // Display Transfer Help
          this.$store.commit('setShowBanner', false); // Hide Banner (so help more obvious)
          const t1 = 'Authentication Error';
          const l1 = 'The Account Number or PIN you specified<br />';
          const l2 = 'for the destination account is not valid.<br />';
          const l3 = 'Verify the destination number is correct<br />';
          const l4 = 'and also review the following two help section:<br />';
          const l5 = '<span style="color:red;">"OTHER" Destination Account</span><br />';
          const l6 = '<span style="color:red;">PIN button (setup Destination Pin)</span>';
          // this.popWarning(t1, `${l1}${l2}${l3}${l4}${l5}${l6}`);
          utl.popWarning(this.$store.commit, t1, `${l1}${l2}${l3}${l4}${l5}${l6}`);
        }
      } else {
        this.lastError = this.alertErrorNumber;
      }
    },
    /* popWarning(title, message) {
      const wm = {}; // Warning Message
      wm.show = true;
      wm.title = title;
      wm.message = message;
      this.$store.commit('setModalWarn', wm);
    }, */
    checkDrops() {
      if (this.form.source === null) {
        this.$store.commit('clrSourceHeader');
      }
      if (this.form.destin === null) {
        this.$store.commit('clrDestinHeader');
      }
    },
    dumpAmounts() {
      this.amounts.forEach(element => utl.diag(element));
    },
    toggleDetail() {
      this.detail = this.detail !== true;
    },
    invalid() {
      const error = this.submitValid.error;
      let msg = 'Please check source, destination, and amount';
      if (error === 1) msg = 'Please select Source account';
      if (error === 2) msg = 'Please select Destination account';
      if (error === 3) msg = 'Please check Source, Destination accounts';
      if (error === 4) msg = 'Please enter a valid transfer amount';
      if (error === 5) msg = 'Not enough available in specified source account';
      this.showAlert(msg);
    },
    submit() {
      // utl.diag('User clicked Transfer');
      const post = {};
      post.cun = this.cun;
      post.acct = this.member.acct;
      post.source = this.form.source;
      post.destin = this.form.destin;
      post.amount = utl.fmtDolCent(utl.stripDollar(this.form.amount));
      this.form.amount = post.amount;
      post.from = this.form.from;
      post.to = this.form.to;
      post.visi = this.visi;
      /* if (post.visi === 'Y') {
        utl.diag('SUBMIT balances are visible');
      } else {
        utl.diag('SUBMIT balances are hidden');
      } */
      this.$store.commit('setXfsAmount', this.form.amount);
      this.$store.commit('setPostData', post);
      this.$store.commit('setPageIndex', 8);
    },
    onBlurAmount() {
      const amount = utl.fmtDolCent(utl.stripDollar(this.form.amount));
      this.form.amount = amount;
    },
    goBack() {
      window.history.back();
    },
    goOther() {
      this.$store.commit('setPageIndex', 17); // goto page 17 (xferOther)
    },
    goHelp() {
      this.showXferHelp = !this.showXferHelp;
      // this.$store.commit('requestHelp', 'TransferHelp');
    },
    goPins() {
      this.$store.commit('clrWpResult'); // Make sure Result Pop-up isn't visible
      this.$store.commit('setPageIndex', 18); // goto page 18 (setupPins)
    },
    diag(msg) {
      this.$store.commit('showDiag', msg);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', `p03: ${message}`);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    clearAlert() {
      this.$store.commit('clrAlertMessage');
    },
    aClick(i) {
      // utl.diag(i);
      this.form.amount = i.value;
    },
    sClick(a, i) {
      // utl.diag(`sClick - ${i.key} - ${i.full}`);
      this.form.source = i.key;
      const xfInfo = {};
      xfInfo.a = a;
      xfInfo.i = i;
      xfInfo.key = i.key;
      xfInfo.full = i.full;
      this.form.from = i.full;
      this.$store.commit('setXfSource', xfInfo);
    },
    dClick(a, i) {
      // utl.diag(`dClick - ${a.key} - ${i.key} - ${i.full}`);
      const key = i.key;
      this.form.destin = key;
      this.visi = i.visi;
      /* if (this.visi === 'Y') {
        utl.diag('balances are visible');
      } else {
        utl.diag('balances are hidden');
      } */
      const xfInfo = {};
      xfInfo.a = a;
      xfInfo.i = i;
      xfInfo.key = key;
      xfInfo.full = i.full;
      this.form.to = i.full;
      this.$store.commit('setXfDestin', xfInfo);
    },
    toggleDestAcct(aPnt) {
      const xfInfo = {};
      xfInfo.aPnt = aPnt;
      xfInfo.all = false;
      this.$store.commit('setXfaPnt', xfInfo);
    },
    expandAllDestAcct(aPnt) {
      const xfInfo = {};
      xfInfo.aPnt = aPnt;
      xfInfo.all = true;
      this.$store.commit('setXfaPnt', xfInfo);
    },
    sourceChange(i) {
      this.writeDiag(`sourceChange - i=${i} key=${i.key}`);
      this.diag(`sourceChange - key='${i.key}' source='${this.form.source}'`);
    },
    mouseEnterSource(i) {
      const xfInfo = {};
      xfInfo.key = i.key;
      xfInfo.style = 'background-color: green; color: white';
      // this.$store.commit('setXfSourceHighlight', xfInfo);
    },
    mouseExitSource(i) {
      const xfInfo = {};
      xfInfo.key = i.key;
      xfInfo.style = i.style;
      // this.$store.commit('setXfSourceHighlight', xfInfo);
    },
    transferRestricted() { // [174]
      const t1 = 'MONEY TRANSFER IS DISABLED';
      const l1 = 'You are accessing an old Database<br />';
      const l2 = 'which does not have current balances.<br />';
      const l3 = 'Please log into our new home banking<br />';
      const l4 = 'program to access the current database<br />';
      const l5 = 'and transfer funds.<br />';
      utl.popWarning(this.$store.commit, t1, `${l1}${l2}${l3}${l4}${l5}`);
    },
  },
  mounted() {
    // utl.diag(this.xfList[0].items);
    if (this.xfs.restore === true) {
      this.form.source = this.xfs.sourceKey;
      this.form.from = this.xfs.sourceFull;
      this.form.destin = this.xfs.destinKey;
      this.form.to = this.xfs.destinFull;
      this.form.amount = this.xfs.amount;
      this.$store.commit('setXfsRestore', false);
    } else {
      this.$store.commit('clearXfList');
    }
    if (this.cuVal === 0) { // [179]
      this.transferRestricted();
    }
    if (this.cuVal === 6) { // [174]
      this.transferRestricted();
    }
  },
  destroyed() {
    // utl.diag('p03-xferFunds - Destroyed()');
  },
};
</script>

<style scoped>
  .xferBackground {
    background: lightgrey;
  }
  .header {
    display: inline-block;
    padding: 0px;
    width: 100%;
    background-color: lightgray;
    color: black;
    font-weight: bold;
    /* border: solid 1px black; */
  }
  .sourceHeadText {
    position: relative;
    text-align: left;
    font-weight: bold;
    background-color: blue;
    color: white;
  }
  .destHeadText {
    position: relative;
    text-align: left;
    font-weight: bold;
    background-color: blue;
    color: white;
    cursor: pointer;
    margin-top: 12px;
  }
  .sourceWind {
    position: relative;
    padding-left: 4px;
    margin-top: 10px;
    min-height: 50px;
    border: solid 1px black;
  }
  .destWind {
    position: relative;
    padding-left: 4px;
    margin-top: 30px;
    min-height: 50px;
    border: solid 1px black;
  }
  .radGroup {
    display: block;
    text-align: left;
  }
  .radBox {
    display: block;
    text-align: left;
    margin-left: 8px;
  }
  .includeSubs {
    position: relative;
    display: inline-block;
  }
  .btnBack {
    position: absolute;
    top: 1px;
    left: 1px;
    background: red;
    color: black;
    font-weight: bold;
    padding: 0px 2px; /* top/bottom then left/right */
    z-index: 100;
    border: solid 2px black;
  }
  .groupHeader {
    display: inline-flex;
    padding: 0px;
    width: 100%;
  }
  .groupSection {
    display: inline-flex;
    vertical-align: center;
    vert-align: middle;
    padding: 0px;
    width: 100%;
    height: 35px;
    cursor: pointer;
    border: dotted 1px white;
  }
  .grHead {
    padding: 0px;
    /* height: 26px; */
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px black;
  }
  .grPrime {
    /* display: inline-flex; */
    text-align: left;
    padding: 0px 0px 0px 4px;
    background-color: transparent;
    font-weight: bold;
    text-decoration: underline;
    border: dotted 1px lightgray;
  }
  .grLeft {
    text-wrap: avoid;
    text-align: left;
    padding: 0px;
    padding-left: 4px;
    height: 30px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .seCheck {
    text-wrap: avoid;
    text-align: left;
    width: 50%;
    padding-left: 30px;
    background-color: transparent;
    font-weight: bold;
    z-index: 99;
  }
  .grRight {
    text-align: right;
    padding: 0px 4px 0px 0px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .sourceItems {
    background-color: lightgrey;
    color: black;
    font-weight: bold;
  }
  .destBox {
    border: solid 1px black;
  }
  .destHead {
    text-wrap: avoid;
    text-align: left;
    padding: 0px 0px 0px 4px;
    height: 40px;
    background-color: green;
    color: white;
    font-weight: bold;
    cursor: pointer;
    font-size: 20px;
  }
  .destItems {
    background-color: lightgrey;
    color: black;
    font-weight: bold;
  }
  .xferLockout { /* [174] */
    background-color: #ffeeba;
    color: black;
    border: solid 1px blue;
  }
  .exitButton { /* [174] */
    background: lightcoral;
    color: black;
    font-weight: bold;
    z-index: 100;
    border: solid 2px black;
    margin-bottom: 10px;
  }
  .topContainer {
    /* border: solid 2px black; */
    /* horiz-align: center; */
    padding-bottom: 0px;
    /* height: 150px; */
  }
  .simpleSelectBox {
    position: relative;
    display: inline-block;
    margin: auto;
    /* border: solid 5px green; */
  }
  .sourceSelector {
    display: inline-block;
    margin: auto;
    padding-top: 0px;
    padding-left: 5px;
    padding-right: 5px;
    width: 300px;
    height: 120px;
    border: solid 1px blue;
  }
  .destinSelector {
    position: relative;
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
    width: 300px;
    height: 120px;
    border: solid 1px blue;
  }
  .selectDestClass {
    position: relative;
    display: inline-block;
  }
  #dropdown-destin {
    left: -10px;
  }
  .cssOther {
    position: absolute;
    top: 8px;
    left: 180px;
    width: 60px;
    height: 38px;
    background-color: yellow;
    color: black;
    font-size: 14px;
  }
  .selectHead {
    font-size: 20px;
    font-weight: bold;
    color: blue;
  }
  #dropdown-source {
    /* */
  }
  .dropHead { /* Account Header in drop-down */
    background-color: blue;
    color: white;
    font-weight: bold;
  }
  .dropItem { /* Account Item in drop-down */
    padding-left: 20px;
    background-color: white;
    color: black;
    font-weight: bold;
  }
  .amtContainer {
    position: relative;
    display: inline-block;
    margin: auto;
    /* height: 50px; */
    /* border: solid 1px grey; */
  }
  .outBoxAmount {
    position: relative;
    display: inline-block;
    width: 300px;
    height: 46px;
    /* border: solid 1px green; */
  }
  .amtBox {
    position: relative;
    display: block;
    margin: auto;
    width: 248px;
    left: 48px;
  }
  .amtInput {
    position: relative;
    top: 4px;
    left: 8px;
    font-size: 14px;
    width: 140px;
    z-index: 100;
    border: solid 1px grey;
  }
  #dropdown-amounts {
    position: absolute;
    left: 108px;
    padding-left: 0px;
    padding-right: 10px;
    top: -3px;
    height: 33px;
    width: 31px;
    z-index: 200;
    background-color: lightgrey;
    /* border: solid 1px black; */
  }
  .amtSelect {
    position: absolute;
    top: 4px;
    left: 8px;
    font-size: 14px;
    width: 150px;
    z-index: 99;
  }
  .outBoxButtons {
    position: relative;
    display: inline-block;
    width: 300px;
    height: 46px;
    /* border: solid 1px red; */
  }
  .btnGroup {
    position: relative;
    display: block;
    margin: auto;
    width: 300px;
  }
  .cssSubmit {
    display: inline-block;
    width: 75px;
    margin: 0px;
    margin-top: 4px;
    margin-left: 1px;
    background-color: green;
    font-size: 14px;
  }
  .cssSubmitDisabled {
    display: inline-block;
    width: 75px;
    margin: 0px;
    margin-top: 4px;
    margin-left: 1px;
    background-color: lightyellow;
    color: black;
    font-size: 14px;
  }
  .cssCancel {
    display: inline-block;
    width: 65px;
    margin: 0px;
    margin-top: 4px;
    margin-left: 1px;
    background-color: red;
    color: black;
    font-size: 14px;
  }
  .cssHelp {
    display: inline-block;
    width: 65px;
    margin: 0px;
    margin-top: 4px;
    margin-left: 1px;
    background-color: cyan;
    color: black;
    font-size: 14px;
  }
  .cssHideHelp {
    background-color: cyan;
    color: black;
    font-size: 14px;
  }
  .cssPins {
    display: inline-block;
    width: 65px;
    margin: 4px 0px 0px 1px;
    background-color: blue;
    color: white;
    font-size: 14px;
  }
  .detailButton {
    position: relative;
    top: 6px;
    padding-top: 4px;
    margin-bottom: 6px;
    height: 30px;
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }

  .xferDesc {
    /* position: absolute; */
    text-align: center;
    left: 0px;
    top: 50px;
    width: 100%;
    /* border: solid 1px green; */
  }
  .center {
    display: inline-block;
    color: black;
  }
  .helpBox {
    border: solid 1px grey;
    background-color: white;
  }
  .helpBoxCenter {
    margin: auto;
    color: blue;
  }
  .helpBoxLeft {
    padding-left: 10px;
    padding-right: 10px;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/p03-xferFunds.vue